export default function ArrowIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12.932" height="12.932" viewBox="0 0 12.932 12.932">
  <g id="Gruppe_28" data-name="Gruppe 28" transform="translate(-1106.47 -83.424)">
    <path id="Pfad_24" data-name="Pfad 24" d="M4.789,7.842,16.441-3.81" transform="translate(1102.211 87.984)" fill="none" stroke="#707070" stroke-width="1.5"/>
    <path id="Pfad_23" data-name="Pfad 23" d="M1128.152,92.712V81.06H1116.5" transform="translate(-9.5 3.114)" fill="none" stroke="#707070" stroke-width="1.5"/>
  </g>
</svg>;
}